'use strict';
var util = require('../../util');

var qvTabsRender = function ($tabs) {
	$tabs.find('.product-tabs').tabs();
};

var mobilePDPTabsHandler = function (productTabs) {
	var tabs = $('.tab-mobile-title');

	if (productTabs.hasClass('ui-tabs')) {
		productTabs.tabs('destroy');
	}

	tabs.each(function () {
		var $currentTab = $(this);
		var currentTabHref = $currentTab.attr('href');
		var content = productTabs.find(currentTabHref);
		$currentTab.removeClass('active');
		content.detach();
		content.insertAfter($currentTab);
	});
	var allContent = tabs.next('.tab-content');
	allContent.removeClass('mb-tab-active');
	allContent.hide();

	tabs.off('click touchstart').on('click touchstart', function (e) {
		var content = $(this).next();
		e.preventDefault();

		$(this).toggleClass('active');
		content.toggleClass('mb-tab-active');
		if (content.hasClass('mb-tab-active')) {
			content.show();
		} else {
			content.hide();
		}
		$('body').animate({
			scrollTop: $(this).offset().top - 50
		});
	});
};

var pdpTabsRender = function ($pt) {
	var prevVP = '';

	var tabsResponsive = function () {
		if (util.viewport.isSmall() && prevVP !== 'small') {
			mobilePDPTabsHandler($pt);
			prevVP = 'small';
		} else if (!util.viewport.isSmall() && prevVP !== 'large') {
			var mobileTabContent = $('.tab-mobile-content .tab-content');
			var desktopTabContent = $('.tab-desktop-content');
			if (!desktopTabContent.children().length) {
				mobileTabContent.each(function () {
					var $tab = $(this);
					$tab.detach();
					desktopTabContent.append($tab);
				});
			}
			$pt.tabs();
			prevVP = 'large';
		}
	};
	tabsResponsive();
	$(window).smartresize(tabsResponsive);
};

var init = function () {
	var $qvTabs = $('.product-qv-tabs .product-tabs'),
		$pdpTabs = $('.tab-target-desktop .product-tabs');
	if ($qvTabs.length > 0) {
		qvTabsRender($qvTabs);
	} else if ($pdpTabs.length > 0) {
		pdpTabsRender($pdpTabs);
		if (util.viewport.isSmall()) {
			var $tabReviews = $pdpTabs.find('#tabReviews');
			$tabReviews.insertAfter('.tab-mobile-content .reviews.tab-mobile-title');
		}
	}
};
exports.init = init;
